import * as React from 'react';
import {
  Table,
  Avatar,
  BatteryIndicator,
} from '@watcherr/ui';
import { t } from '~/i18n';
import { DeviceEntryProps, DeviceType } from '@watcherr/resources';
import { useProfile } from '~utils/profile';

export const LowBatteryDeviceTable: React.FC<{
  devices: DeviceEntryProps[];
}> = ({ devices }) => {
  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCol>{t('alert.status.lowBatterySection.table.name')}</Table.HeadCol>
          <Table.HeadCol>{t('alert.status.lowBatterySection.table.deviceType')}</Table.HeadCol>
          <Table.HeadCol>{t('alert.status.lowBatterySection.table.batteryLevel')}</Table.HeadCol>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {devices.map((device) => <Row device={device} />)}
      </Table.Body>
    </Table>
  );
};

function Row({ device }: { device: DeviceEntryProps }) {
  const resident = useProfile(device.ownerId)
  return (
    <Table.Row
      key={`alert-table-row-${device.id}`}
    >
      <Table.Col>
        <Avatar
          userInfo={{
            name: resident ? (resident?.firstName + " " + resident?.lastName) : device.description ?? device.macAddress,
            function: '',
          }}
        />
      </Table.Col>
      <Table.Col>
        {t(`device.types.${device.deviceType?.toLowerCase()}`)}
      </Table.Col>
      <Table.Col>
        {typeof device.batteryLevel == "number" ? <BatteryIndicator inaccurate={device.deviceType !== DeviceType.WATCHERR}
          percentage={device.batteryLevel} width={30} /> : "-"}
      </Table.Col>

    </Table.Row>
  )
}
